import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=fc6a35cc&"
import script from "./departments.vue?vue&type=script&lang=js&"
export * from "./departments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports